export const getPlacement = (placements: Array<App.Banner> = [], position: App.BannerPosition) => placements.filter(placement => placement.position === position)
